module.exports = __webpack_public_path__ + "img/c_sv1.7ea7f37.png";